import { Box, Flex, Text, HStack, Link, Separator } from '@chakra-ui/react';

export const Footer = () => {
  return (
    <Box as="footer" py={5} px={{ base: 6, md: 12 }} mt={20}>
      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify="space-between"
        align="center"
        mb={6}
        gap={6}
      >
        <Text fontSize="md">Fernsology</Text>

        <HStack>
          <Link
            href="https://fernsology.substack.com/subscribe"
            _hover={{ color: '#A67C52' }}
          >
            <Text fontSize="md">Newsletter</Text>
          </Link>
        </HStack>
      </Flex>

      <Separator borderColor="#6B8E8E" opacity={0.4} mb={6} />

      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify="space-between"
        align="center"
        gap={2}
      >
        <Text fontSize="sm" opacity={0.7}>
          © Fernsology 2025 - Today. All rights reserved.
        </Text>
        <Text fontSize="sm" opacity={0.7}>
          Designed & Created by:{' '}
          <a
            href="https://funmiolaiya.com/"
            target="_blank"
            style={{ textDecoration: 'underline' }}
            rel="noreferrer"
          >
            Funmi Olaiya
          </a>
        </Text>
      </Flex>
    </Box>
  );
};
